import { Injectable } from '@angular/core';
import { ConfigDataService } from '@app/_services/config-data.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PlanDetails } from '@app/_models/planDetails';

export interface ProductMasterReport extends PlanDetails {
  isVariable: boolean;
  preGst?: number;
  gst?: number;
  cost?: number;
}

@Injectable({
  providedIn: 'root'
})
export class ProductMasterService {

  constructor(private configDataService: ConfigDataService) { }

  /**
   * Get all plans from planDetails and transform them to ProductMasterReport format.
   * Role-specific filtering is handled in the component layer.
   */
  getProductMasterPlans(): Observable<ProductMasterReport[]> {
    return this.configDataService.PlanDetails$.pipe(
      map(plans => plans.map(plan => this.transformToPlanReport(plan)))
    );
  }

  /**
   * Transform a PlanDetails object to ProductMasterReport format
   */
  private transformToPlanReport(plan: PlanDetails): ProductMasterReport {
    const planAmount = plan.planAmount || 0;
    const isVariable = planAmount === 0;

    return {
      ...plan,
      isVariable: isVariable,
      preGst: plan.planAmount,
      gst: plan.planGstAmount,
      cost: plan.planAmount
    };
  }
}
